import { isNotDefined } from '@sgme/fp';
import deepEqual from 'fast-deep-equal';
import { createContext, use, useCallback } from 'react';

import type { FxFlexiForward } from '@/store/flexi-forward/state.ts';
import { useAppSelector } from '@/store/hooks.ts';
import type { AppState } from '@/store/store.ts';

export const FlexiForwardContext = createContext<string>('');

export function useFlexiForwardSelector<T>(selector: (flexiForward: FxFlexiForward, state: AppState) => T): T {
  const tileId = use(FlexiForwardContext);

  if (isNotDefined(tileId)) {
    throw new Error('Could not find tileId');
  }

  // oxlint-disable-next-line exhaustive-deps -- selector is intentionally locked to its first value for a stable reference
  const select = useCallback(selector, []);

  const selectorMemo = useCallback(
    (state: AppState): T => {
      const flexiForward = state.flexiForward[tileId];

      if (isNotDefined(flexiForward)) {
        throw new Error(`Could not find flexi forward with tileId ${tileId}`);
      }

      return select(flexiForward, state);
    },
    [select, tileId],
  );

  return useAppSelector(selectorMemo, deepEqual);
}
